import preview from '../assets/images/Homepage-Social-Post-Showcase-LINKEDIN.png';

import '../styles/Homepage.scss';
import MetaDecorator from './MetaDecorator';

export default function Homepage(props) {
  return (
    <section className="homepage">
      <MetaDecorator title="Courageous Showcase" description="" image={preview} />
      <div className="header">
        <h1 className="subhead">A Courageous Year of Storytelling</h1>
        <p>
          At Courageous, 2022 was a chance to tell{' '}
          <span style={{ fontFamily: 'Lato Bold' }}>bigger, more impactful human stories.</span>
        </p>
        <p>
          We championed the work of{' '}
          <span style={{ fontFamily: 'Lato Bold' }}>
            HIV-prevention activists in the Deep South.
          </span>{' '}
        </p>
        <p>
          We <span style={{ fontFamily: 'Lato Bold' }}>built a spacesuit</span> with Morgan Stanley
          and <span style={{ fontFamily: 'Lato Bold' }}>dropped it in Times Square.</span>
        </p>
        <p>
          And we had our{' '}
          <span style={{ fontFamily: 'Lato Bold' }}>first feature film debut on HBO Max </span> in
          partnership with Ally.
        </p>
        <p>
          Thank you to all of our amazing partners and colleagues for helping to bring these stories
          and many others to life. Happiest of holiday wishes from all of us to all of you.
        </p>
        <p></p>
      </div>
      <div className="grid-container">
        <div className="value-grid">
          {props.data.map((item, index) => {
            return (
              <div
                className={`square s${index + 1}`}
                id={`${item.theme}`}
                key={index}
                onClick={(e) => {
                  e.preventDefault();
                  console.log('index', index);
                  props.setCurrentPage(index);
                  window.location = `/${item.theme}`;
                }}
              >
                <img src={item.poster} alt="poster" />
                <video src={item.loop} poster={item.poster} autoPlay muted loop playsInline />

                <div className="video-info">
                  <p className="title">{item.title}</p>
                  <p className="brand">{item.brand}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
